import { roles } from "../config/config";

export const budgetPermissions = [
  roles.admin,
  roles.gestore,
  roles.developer,
  roles.contabile,
  roles.agenteRoydermal,
  roles.agenteRoypet,
  roles.agenteValderma,
  roles.agenteCompleto,
].filter((role) => typeof role === "number");
